import { getProxyUrl } from '.'
import { OpenProjectResponse } from '@types'
import { DEFAULT_CULTURE } from '@utils/i18nLocale'

export async function openProyect(id: number, tmp = false): Promise<OpenProjectResponse | undefined> {
  let url
  if (tmp) {
    url = getProxyUrl('api/Diseno/abrirdisenyotmp/')
  } else {
    url = getProxyUrl('api/Diseno/abrirdisenyo/')
  }
  const params = {
    id,
    method: 'GET',
    mode: 'cors',
    headers: {
      'Accept-Language': 'ES',
      'Content-Type': 'application/json',
      Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
    },
  }

  try {
    const data = await fetch(url + id, params as RequestInit)
    if (data.status === 200) {
      const json = await data.json()
      return json as OpenProjectResponse
    } else {
      return
    }
  } catch (e: any) {}
}

/**
 * Abre un proyecto compartido por enlace (el token que llega en el correo de
 * presupuesto: https://<host>/?token=XXXX). El back resuelve el token a un
 * diseño temporal y devuelve la misma estructura que `abrirdisenyo`.
 */
export async function openProyectByToken(token: string): Promise<OpenProjectResponse | undefined> {
  const url = getProxyUrl('api/Diseno/abrirdisenyotmp')
  const params: RequestInit = {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Accept-Language': DEFAULT_CULTURE,
      'Content-Type': 'application/json',
      Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
    },
  }

  try {
    const data = await fetch(`${url}?token=${encodeURIComponent(token)}`, params)
    if (data.status !== 200) {
      console.error('[openProyectByToken] El back rechazó el token', data.status)
      return
    }
    const json = await data.json()
    return json as OpenProjectResponse
  } catch (e) {
    console.error('[openProyectByToken] Error abriendo el proyecto compartido', e)
  }
}
